import { css } from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        form: css`
            ${custom.stepElementPadding};
            ${common.flexJustityAlignCenter};
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
        `,
        button: css`
            ${common.stepsPictureButton};
        `,
    }
}

export default styles
